__turbopack_context__.v({
  "content": "gifts-packages-modal-module-scss-module__BufS-W__content",
  "footer": "gifts-packages-modal-module-scss-module__BufS-W__footer",
  "grid": "gifts-packages-modal-module-scss-module__BufS-W__grid",
  "gridWrapper": "gifts-packages-modal-module-scss-module__BufS-W__gridWrapper",
  "heading": "gifts-packages-modal-module-scss-module__BufS-W__heading",
  "item": "gifts-packages-modal-module-scss-module__BufS-W__item",
  "itemImg": "gifts-packages-modal-module-scss-module__BufS-W__itemImg",
  "itemTitle": "gifts-packages-modal-module-scss-module__BufS-W__itemTitle",
  "packageCard": "gifts-packages-modal-module-scss-module__BufS-W__packageCard",
  "packagePreview": "gifts-packages-modal-module-scss-module__BufS-W__packagePreview",
  "root": "gifts-packages-modal-module-scss-module__BufS-W__root",
});
